export function parseInt(value, radix = 10) {
  return window.parseInt(value, radix);
}

export function replaceAll(str, regex, replacement) {
  return str.replace(new RegExp(regex, "gu"), replacement);
}
